"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiIconButton = void 0;
const callable_1 = require("client/components/ui/callable");
const react_1 = require("react");
const React = require("react");
require("./icon-button.less");
class UiIconButton extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleClick = (event) => {
            callable_1.callable(this.props.onClick)(event);
        };
    }
    render() {
        const { className = "", disabled, primary, small } = this.props;
        const primaryClass = primary ? "ui-icon-button--primary" : "";
        const smallClass = small ? "ui-icon-button--sm" : "";
        return (React.createElement("button", { className: `ui-icon-button ${primaryClass} ${smallClass} ${className}`, disabled: disabled, onClick: this.handleClick, type: "button" }, this.props.children));
    }
}
exports.UiIconButton = UiIconButton;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/icon-button/icon-button.tsx
// module id = 3617
// module chunks = 0